import { FC } from 'react';
import {useIntl} from 'react-intl'

import { ChatModel } from '../../../models/chat';

import { useChat } from '../../../context/chat';
import { useLang } from '../../../../_metronic/i18n/Metronici18n'

import { classifyDate } from '../../../utils';

import ChatOptions from './ChatOptions'

interface Props {
  chat: ChatModel;
  previousChat: ChatModel | null;
  goChat: () => void;
  handleDeleteChat: () => void;
}

const Chat: FC<Props> = ({ chat, previousChat, goChat, handleDeleteChat}) => {
  
  const intl = useIntl()


  const { state : {currentChat} } = useChat()

  const selectedLang = useLang()

  const setCurrentChat = () => {  
    goChat()
  }

  return (
    <>
    {previousChat == undefined || previousChat && classifyDate(chat.recent_message_created_dt ? chat.recent_message_created_dt : chat.created_dt, selectedLang, intl ) != classifyDate(previousChat.recent_message_created_dt ? previousChat.recent_message_created_dt : previousChat.created_dt, selectedLang, intl) ? (
      <div className="text-start mt-5 mb-1 ms-5">
        <div className="fs-8 text-muted fw-semibold">
          {classifyDate(chat.recent_message_created_dt ? chat.recent_message_created_dt : chat.created_dt, selectedLang, intl)}
        </div>
      </div>
    ):''}
    <div className={`mx-2 rounded chat fs-6 ${currentChat && currentChat.id == chat.id && 'chat-selected'}`} >
      <div className="d-flex chat-name-area p-3" onClick={setCurrentChat}>
        <div className="chat-name" data-content="name">{chat.name ? chat.name : intl.formatMessage({id: 'chat.new'})}</div>
      </div>
      <div className="chat-options rounded pt-3 pe-3 ps-2">
        <ChatOptions chat={chat} handleDeleteChat={handleDeleteChat}/>
      </div>
    </div>
    </>
  )
}
export { Chat };